import { render, staticRenderFns } from "./cInsights.vue?vue&type=template&id=88eb09b2&scoped=true"
import script from "./cInsights.vue?vue&type=script&lang=js"
export * from "./cInsights.vue?vue&type=script&lang=js"
import style0 from "./cInsights.vue?vue&type=style&index=0&id=88eb09b2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88eb09b2",
  null
  
)

export default component.exports